import { makeStyles } from "@material-ui/core";

import { LevelIcon } from "./LevelIcon";
import { Cooperation } from "../../gardener/gardener.model";
import { determineLevelText, determineNumberOfTasksBenefit, determinePriorityBenefit } from "../utility";

const useStyles = makeStyles({
    root: {
        width: "100%",
        maxWidth: "512px",

        "&.dense": {
            paddingBottom: "8px",
        },
    },
    label: {
        backgroundColor: "#0076EB",
        padding: "4px",
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",

        fontSize: "12px",
        fontWeight: 500,
        color: "#FFFFFF",
        fontVariant: "small-caps",
        textAlign: "center",
    },
    container: {
        padding: "16px",
        border: "1px solid rgba(0,0,0, 0.2)",
        borderRadius: "20px",

        "&.selected": {
            borderTop: "none",
            borderWidth: "2px",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
    },
    header: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        fontSize: "16px",
        fontWeight: 600,
        color: "#4A4A4A",
        marginBottom: "16px",

        "& > svg": {
            fontSize: "24px",
            marginRight: "4px",
        },
    },
    benefit: {
        fontSize: "14px",
        fontWeight: 400,
        color: "#4A4A4A",
        textAlign: "center",

        marginLeft: "-2px", // Necessary to fit on three lines
        marginRight: "-2px", // Necessary to fit on three lines
        marginBottom: "24px",

        "&:last-child": {
            marginBottom: 0,
        },

        "&.dense": {
            marginBottom: "16px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
});

interface LevelProps {
    cooperationLevel: Cooperation["level"];
    selected: boolean;
    dense?: boolean;
}

export const Level = (props: LevelProps) => {
    const classes = useStyles();
    const { cooperationLevel, selected, dense } = props;

    const levelText = determineLevelText(cooperationLevel);
    const numberOfTasksBenefit = determineNumberOfTasksBenefit(cooperationLevel);
    const priorityBenefit = determinePriorityBenefit(cooperationLevel);

    return (
        <div className={`${classes.root} ${selected ? "selected" : "not-selected"} ${dense ? "dense" : "not-dense"}`}>
            {selected ? <div className={classes.label}>dit niveau</div> : null}

            <div className={selected ? `${classes.container} selected` : classes.container}>
                <div className={classes.header}><LevelIcon cooperationLevel={cooperationLevel} />{levelText}</div>
                <div className={dense ? `${classes.benefit} dense` : classes.benefit}>{numberOfTasksBenefit}</div>
                <div className={dense ? `${classes.benefit} dense` : classes.benefit}>{priorityBenefit}</div>
            </div>

        </div>
    );
};
